import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/reportes.service";

const initialState = {
    reportesVentas:[],
    reportesVentasMensuales:[], 
    rankingVentasClientes : [],
    isLoading: false,
    isError: false,
    message: ''
};
export const getReportesVentas = createAsyncThunk(
    "reportes/getReportesVentas",
    async (_, thunkAPI) => {
        try {
            return await service.getReportesVentas();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getReportesVentasMensuales = createAsyncThunk(
    "reportes/getReportesVentasMensuales",
    async (_, thunkAPI) => {
        try {
            return await service.getReportesVentasMensuales();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getRankingVentasClientes = createAsyncThunk(
    "reportes/getRankingVentasClientes",
    async (_, thunkAPI) => {
        try {
            return await service.getRankingVentasClientes();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const reportesSlice = createSlice({
    name: "reportes",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReportesVentas.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getReportesVentas.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.reportesVentas = action.payload;
            })
            .addCase(getReportesVentas.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getReportesVentasMensuales.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getReportesVentasMensuales.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.reportesVentasMensuales = action.payload;
            })
            .addCase(getReportesVentasMensuales.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getRankingVentasClientes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getRankingVentasClientes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.rankingVentasClientes = action.payload;
            })
            .addCase(getRankingVentasClientes.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    },
});
export const { reset } = reportesSlice.actions;
export default reportesSlice.reducer;